import { render, staticRenderFns } from "./HistorialGuardia.vue?vue&type=template&id=0cb76d04&"
import script from "./HistorialGuardia.vue?vue&type=script&lang=js&"
export * from "./HistorialGuardia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports